import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("DocumentContentGetInput")
export class DocumentContentGetInput {
    @JsonProperty("mediaId", String, true)
    public mediaId: string = JsonPropertyEmpty;

    public constructor(args?: Partial<DocumentContentGetInput>) {
        Object.assign(this, args);
    }
}
